module.exports = __webpack_public_path__ + "img/img7.abb77092.png";